import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'nest-card',
  styleUrl: 'nest-card.scss',
  shadow: true,
})
export class NestCard {
  @Prop() header: string;
  @Prop() icon: string;
  @Prop() action: boolean;
  @Prop() redirect: boolean;

  render() {
    return (
      <Host>
        <div class={{
          'nest-card': true,
          'nest-card--redirect': this.action || this.redirect
        }}>
          <slot name='image'/>

          {this.icon &&
            <nest-icon name={this.icon} class='nest-card__icon'/>
          }

          <div class="flex flex-col space-y-1 p-4">
            {this.header && <h4>{this.header}</h4>}

            <p class="nest-card__content">
              <slot/>
            </p>
          </div>

          {this.redirect &&
            <nest-icon name='chevron-right' class='nest-card__redirect'/>
          }
        </div>
      </Host>
    );
  }
}
